import React from "react";
import { createRoot } from "react-dom/client";
import ESignatureConfirmModal from "./ESignatureConfirmModal";

let root = null;
let container = null;

function cleanup() {
  try {
    if (root) root.unmount();
  } catch {
    /* ignore */
  }
  root = null;
  try {
    if (container?.parentNode) container.remove();
  } catch {
    /* ignore */
  }
  container = null;
}

/**
 * Promise API matching openAuthModal — eISF-style signature confirm.
 * Resolves { Success: 1, SignatureBase64 } on Yes, or cancelled on No/close.
 */
export function openESignatureConfirmModal(options = {}) {
  return new Promise((resolve) => {
    let settled = false;

    const finish = (value) => {
      if (settled) return;
      settled = true;
      cleanup();
      resolve(value);
    };

    if (container || root) cleanup();

    container = document.createElement("div");
    document.body.appendChild(container);
    root = createRoot(container);

    root.render(
      <ESignatureConfirmModal
        show
        {...options}
        onClose={() =>
          finish({ Success: 0, success: false, cancelled: true })
        }
        onConfirm={(data) =>
          finish({
            ...data,
            Success: 1,
            success: 1,
            cancelled: false,
          })
        }
      />,
    );
  });
}
